module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAwCAYAAABOiRchAAABOklEQVRoge3YMUpDURBG4XM1VZAgklq3YK2p3ISFLsAyjYKNnSAIIiKBLEFwDenSZQGKK7AQq0AeIk+G0QduIHfgn7OCma+Y5N2yeTE7BB6BAXp9AQ894ArYFwT463YD6MeYpVp9Q5DPEF7EEV7tJoyBBbAdYKB1Z4fx2RCWwFRr9/+Vtm0jzVMl+cNIInjyCCSCJ49AInjyCCSCJ49AInjyCCSCZ2+MEeaomn1KD4EzYEtw/2/gyRDugZMAA9Xq1G7CnubuXbvyh5HfX4ePAHPU7NNuwjnQADuCACtgYghvwHGAgaol/9BK/mP05BFIBE8egUTw5BFIBE8egUTw5BFIBE8egXxo9exTugBHwu8JM0O4Bi4DDFSrud2EkebuXQeGUIIMU6tiCI3m7l2NIdwB70EGWndL4OYH7vMm8FvN7z8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 0